import {

    ACTION_POST_CHANGEPASSWORDSECURITY,
  
  } from "@/views/change_password_security/store/types/types.js";
  
  import Swal from 'sweetalert2';
  import { changePassSecurityService } from "../../../services";
  
  const actions = {

    [ACTION_POST_CHANGEPASSWORDSECURITY]: ({ state }, changenPassSecurity) => {
      return new Promise((resolve, reject) => {
        try {
          state.loadingchangePassSecurityService = true;
    
          const idGroup = sessionStorage.getItem("idGroup");
          const idEmpresa = sessionStorage.getItem("idEmpresa");
          const idUsuario = sessionStorage.getItem("idUsuario"); 
    
          changePassSecurityService.postChangePasswordSecurity({ idGroup, idEmpresa, idUsuario, changenPassSecurity })
            .then(async response => {
              await Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: "La contraseña fue actualizada exitosamente",
                showConfirmButton: false,
                timer: 2500
              })
    
              resolve(response.data);
            })
            .catch(error => {
              reject(error);
            })
            .finally(() => {
              state.loadingchangePassSecurityService = false;
            });
        } catch (error) {
          console.error("Error en la solicitud:", error);
          reject(error);
        }
      });
    },
    

  }


export default actions